import React from 'react';
import {NavLink, useLocation} from "react-router-dom";
import {
    CATEGORY_BLOCK_HOUSE,
    CATEGORY_EDGED_BOARD, CATEGORY_EVRO_VAGONKA, CATEGORY_FLOOR_BOARD, CATEGORY_IMITATION_TIMBER,
    CATEGORY_PLANED_BLOCK,
    CATEGORY_PLANED_BOARD, CATEGORY_SHTIL
} from "../utils/consts";

const SideBar = () => {
    const location = useLocation();
    return (
        <aside className="sidebar_widget">
            <div className="widget_inner">
                <div className="widget_list widget_categories">
                    <h3>Продукция</h3>
                    <ul>
                        <li><NavLink className={`${location.pathname === CATEGORY_PLANED_BOARD && 'widget_active_link' }`} to={CATEGORY_PLANED_BOARD}>Доска строганная</NavLink></li>
                        <li><NavLink className={`${location.pathname === CATEGORY_PLANED_BLOCK && 'widget_active_link' }`} to={CATEGORY_PLANED_BLOCK}>Брусок строганный</NavLink></li>
                        <li><NavLink className={`${location.pathname === CATEGORY_EDGED_BOARD && 'widget_active_link' }`} to={CATEGORY_EDGED_BOARD}>Доска обрезная 1 сорт</NavLink></li>
                        <li><NavLink className={`${location.pathname === CATEGORY_BLOCK_HOUSE && 'widget_active_link' }`} to={CATEGORY_BLOCK_HOUSE}>Блок-Хаус</NavLink></li>
                        <li><NavLink className={`${location.pathname === CATEGORY_IMITATION_TIMBER && 'widget_active_link' }`} to={CATEGORY_IMITATION_TIMBER}>Имитация Бруса</NavLink></li>
                        <li><NavLink className={`${location.pathname === CATEGORY_SHTIL && 'widget_active_link' }`} to={CATEGORY_SHTIL}>Штиль</NavLink></li>
                        <li><NavLink className={`${location.pathname === CATEGORY_FLOOR_BOARD && 'widget_active_link' }`} to={CATEGORY_FLOOR_BOARD}>Доска пола</NavLink></li>
                        <li><NavLink className={`${location.pathname === CATEGORY_EVRO_VAGONKA && 'widget_active_link' }`} to={CATEGORY_EVRO_VAGONKA}>Евро-Вагонка</NavLink></li>
                    </ul>
                </div>
            </div>
        </aside>
    );
};

export default SideBar;